module.exports = __webpack_public_path__ + "media/customizations/austinpoint/logo-new-cd4c084e5af78816bdad1e65b9b0c4b2.png";